import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { NavGroupType } from '@/modules/core/nav/constants/NavGroupType';

export class NavItemGroup extends BaseModel {
  key?: NavGroupType;
  title?: string;

  constructor(model: Partial<NavItemGroup> = {}) {
    super(model);

    this.key = model.key;
    this.title = model.title;
  }
}
